/* global newsletter_ajax_url */

export default {
  init() {
    newsletter();
  },
};

export var newsletter = () => {
  $(document).ready(function($) {
    $('.newsletter-button').click(function(e) {
      e.preventDefault();
      $.ajax({
        type: 'POST'
        ,dataType: 'json'
        ,url: newsletter_ajax_url.ajax_url
        ,data: {
          'action': 'change_newsletter',
        }
        ,success: function(response) {
          if ($('.woocommerce-message')[0]){
            $('.woocommerce-message').append('<li>' +response+ '</li>');
          } else {
            $('.woocommerce-notices-wrapper').append('<ul class="woocommerce-message" role="alert"><li>' +response+ '</li></ul>');
          }
        },
      });
    });
  });
}
